import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import OrderForm from '@views/orders/OrderForm';
import OrderProductFormBody from './OrderProductFormBody';
import TasksTab from './TasksTab';
import OperationsTab from '@views/order-products/OperationsTab';
import ChecklistsTab from '@views/order-products/ChecklistsTab';
import MaterialsTab from '@views/order-products/MaterialsTab';

const customFields = {
    products: {
        component: OrderProductFormBody,
    },
    _tasks: {
        component: TasksTab,
    },
    _operations: {
        component: OperationsTab,
    },
    _materials: {
        component: MaterialsTab,
    },
    _checklists: {
        component: ChecklistsTab,
    },
};

export default class OrderProductForm<Model extends IOrderModel> extends OrderForm<Model> {
    protected get customFields() {
        return customFields as any;
    }

    protected get initialValues() {
        return this.props.model ? {
            products: [
                this.getProductInitialData(this.props.model as any)
            ]
        } : {};
    }
}
